/**
 * SECURITY-PAGE-TRUTH-1 (TR-2026-10-16-8 A5) — rules the server always enforces.
 *
 * An entry belongs here only if its proving test is collected and run by a
 * required CI job. Evidence (job log, SHA) is recorded in the PR that adds the
 * entry; `proof` names the spec and the required check it runs under. Never
 * add an entry from a file's existence alone. Settings an admin can change are
 * not invariants and stay on their own tabs.
 */
export type SecurityInvariant = {
  id: string;
  statement: string;
  proof: { spec: string; requiredCheck: string }[];
};

export const SECURITY_INVARIANTS: SecurityInvariant[] = [
  {
    id: "gate-no-self-decision",
    statement: "Nobody approves or rejects their own phase gate submission.",
    proof: [
      { spec: "src/modules/work-management/services/gate-approval-engine.service.spec.ts", requiredCheck: "C1 Gates (no Docker)" },
      { spec: "src/modules/work-management/services/__tests__/gate-deadlock-prove.real-schema.spec.ts", requiredCheck: "Contract Tests Gate" },
    ],
  },
  {
    id: "exception-no-self-approval",
    statement: "Nobody approves their own governance exception.",
    proof: [
      { spec: "src/modules/governance-exceptions/__tests__/self-approval-residual.real-schema.spec.ts", requiredCheck: "Contract Tests Gate" },
    ],
  },
  {
    id: "last-admin",
    statement: "The last active admin can't be demoted.",
    proof: [
      { spec: "src/organizations/services/__tests__/last-admin-guard.rbac.spec.ts", requiredCheck: "C1 Gates (no Docker)" },
    ],
  },
  {
    id: "workspace-delete-admin-only",
    statement: "Only admins can delete or archive a workspace.",
    proof: [
      { spec: "src/modules/workspaces/services/workspace-permission.service.spec.ts", requiredCheck: "C1 Gates (no Docker)" },
    ],
  },
  {
    id: "suspended-member",
    statement: "Suspended members can't change workspace settings or members.",
    proof: [
      { spec: "src/modules/workspaces/services/__tests__/ws-suspended-perms-1.real-schema.spec.ts", requiredCheck: "Contract Tests Gate" },
    ],
  },
  {
    id: "password-change-sessions",
    statement: "Changing a password signs you out on your other devices.",
    proof: [
      { spec: "src/modules/auth/__tests__/password-change-session-invalidation.real-schema.spec.ts", requiredCheck: "Contract Tests Gate" },
    ],
  },
];
